<template>
    <div class="wg-row">
      <div class="wg-row">
        <div class="display-flex project-name" :style="{borderLeft: '4px solid' + statusColor}">
          {{ $anm22.getProjectFullLabel(project) }}
          <img 
              v-if="!isSynchronized"
              :src="$anm22.icons.getWorldIcon('offline')"
              class="com-anm22-app-img-fixed-height-m"
              style="margin-left:5px;"
              :title="$anm22.strLang(lang, 'Not synchronized', 'Non sincronizzato')"
          >
          <img 
              v-if="canEdit"
              class="com-anm22-app-img-fixed-height-s"
              style="cursor:pointer;margin-left:5px;"
              :title="$anm22.strLang(lang, 'Edit project', 'Modifica progetto')"
              :src="$anm22.icons.getWorldIcon('edit')"
              @click="editProject">
        </div>
        <div class="wg-sm-none vertical-height-div" style="height:5px;"></div>
        <!-- Utenti -->
        <div class="display-flex users-div">
          <div 
              v-for="(u,index) in projectUsers"
              :key="'u'+index">
            <world-object-icon
                :type="'user'" 
                :obj="u"
                :isImg="true">
            </world-object-icon>
          </div>
        </div>
      </div>
      <template v-if="project.description">
        <div class="vertical-height-div" style="height:5px;"></div>
        <div class="com-anm22-app-text-l" style="width:100%;overflow:hidden;white-space:normal;text-overflow:ellipsis;">
          {{ project.description }}
        </div>
      </template>
      <div class="vertical-height-div" style="height:5px;"></div>
      <!-- Date di progetto -->
      <div class="wg-row">
        <div v-if="project.startDate" class="com-anm22-app-text-m">
          {{ $moment.unix(project.startDate).utc().format('DD-MM-YYYY') + '&nbsp;-&nbsp;'}}
        </div>
        <div v-if="project.endDate"  class="com-anm22-app-text-m">
          {{ $moment.unix(project.endDate).utc().format('DD-MM-YYYY')}}
        </div>
      </div>
      <div class="vertical-height-div" style="height:5px;"></div>
      <div class="wg-row">
        <!-- Immagine e nome clienti, se presenti -->
        <router-link :to="'/project/edit/' + project.idWorldProject + '?page=customers'">
          <div class="wg-row">
            <template v-if="customers.length > 0">
              <div
                  v-for="(customer,index) in customers"
                  :key="'cust-'+index"
                  class="display-flex"
                  style="align-items:center;flex-wrap:nowrap;margin-left:5px;"
              >
                <img 
                    :src="$anm22.getContactIcon(customer, $store)"
                    class="com-anm22-app-img-fixed-height-m com-anm22-round"
                >
                <div class="com-anm22-app-horizontal-space" style="width:5px;"></div>
                <div class="com-anm22-app-text-m">{{ $anm22.getContactName(customer, $store) }}</div>
              </div>
            </template>
            <div v-else>
              <div class="select-client-btn com-anm22-app-text-m com-anm22-button">
                {{ $anm22.strLang(lang, 'Select customer', 'Seleziona cliente') }}
              </div>
            </div>
          </div>
        </router-link>
      </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    projectId: [Number, String],
    customerManager: [Boolean]
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
      user: state => state.auth.user
    }),
    project() {
      return this.$store.getters['projects/get'](this.projectId);
    },
    isSynchronized() {
      return this.$store.getters['offline/isSynchronized'](this.$anm22.MD5('WorldProject' + this.projectId));
    },
    projectUsers() {
      return this.project.users.map(u => this.$store.getters['users/get'](u)).filter(u => u);
    },
    customers() {
      return this.project.customers.map(c => this.$store.getters['contacts/get'](c)).filter(c => c);
    },
    userPermission() {
      return this.$store.getters['employments/getPermByProject'](this.project);
    },
    licenses() {
      return this.$store.getters["employments/getByUser"](this.user.idWorldUser)
        .filter(e => this.project.developers.includes(e.work))
        .map(e => this.$store.getters["licenses/getByWork"](e.work))
        .filter(l => l);
    },
    canEdit() {
      const functions = this.licenses
        .filter(
          l =>
            l.config.tasks &&
            l.config.tasks.project &&
            l.config.tasks.project["edit-rules"]
        );
      if(functions) {
        return functions.reduce(
          (result, l) => {
            return result && this.$anm22[l.config.tasks.project["edit-rules"]](this, this.project)
          },
          true
        );
      } else {
        return this.userPermission <= 3 || this.customerManager;
      }
    },
    statusColor() {
      switch (this.project.status) {
        case 1:
          return "#bdbdbd";
        case 2:
          return "#ffeb3b";
        case 3:
          return "#01d479";
        case 4:
          return "#00B0FF";
        case 5:
          return "#ff0000";
        case 6:
          return '#fff';
      }
    }
  },
  methods: {
    editProject() {
      const route = '/project/edit/'+this.project.idWorldProject;
      this.$router.push(route);
    }
  }
};
</script>

<style lang="scss" scoped>

.project-name {
  font-weight: normal;
  padding-left: 5px;
  font-size: 24px;
  flex-wrap: nowrap;
  align-items: center;
  margin-right: 10px;
}
.users-div {
  overflow:hidden;
  height:26px;
  flex-wrap:nowrap;
  align-items:center;
  white-space:nowrap;
  box-sizing:border-box;
  position: relative;
  margin-right: 10px;
  flex: 1;
}
.users-div > div {
  position: absolute;
  min-width:26px;
  width:26px;
  height:26px;
  display: block;
  border: 2px solid #fafafa;
  border-radius: 13px;
  top:0px;
  left:0px;
}
.users-div > div:nth-child(1) {
  left:0px;
  z-index: 11;
}
.users-div > div:nth-child(2) {
  left:22px;
  z-index: 10;
}
.users-div > div:nth-child(3) {
  left:44px;
  z-index: 9;
}
.users-div > div:nth-child(4) {
  left:66px;
  z-index: 8;
}
.users-div > div:nth-child(5) {
  left:88px;
  z-index: 7;
}
.users-div > div:nth-child(6) {
  left:110px;
  z-index: 6;
}
.users-div > div:nth-child(7) {
  left:132px;
  z-index: 5;
}
.users-div > div:nth-child(8) {
  left:154px;
  z-index: 4;
}
.users-div > div:nth-child(9) {
  left:176px;
  z-index: 3;
}
.users-div > div:nth-child(10) {
  left:198px;
  z-index: 2;
}
.select-client-btn {
  padding: 4px;
}
</style>
